import React from "react";

import Browse, { FilterData } from "../../components/browse/Browse";
import GlossaryList from "../../components/browse/GlossaryList";
import { useFilterQueryParam } from "../../components/browse/useSearch";

const defaultSearchFilter: FilterData = {
  subject: undefined,
  grade: [],
  type: ["VOCABULARY"],
  query: "",
};

const GlossaryRoute = () => {
  const [searchFilter, setSearchFilter] =
    useFilterQueryParam(defaultSearchFilter);

  return (
    <Browse
      pageTitle="Glossary"
      resultList={GlossaryList}
      searchQuery="SearchVocabulary"
      withFilters={{
        bank: true,
        subject: true,
        language: true,
        grade: false,
        objectives: false,
        type: false,
        query: true,
      }}
      searchFilter={searchFilter}
      setSearchFilter={setSearchFilter}
    />
  );
};

export default GlossaryRoute;
